const STATE = {
  leftNavData: null,
  selectedNavItem: null,
  initialLeftNavData: null,
};
  
export default STATE;